(function (window, $) {
  var Cls = {};
  var firstFlag = false;
  var $title = null;
  var $cat0_obj1 = null;
  var $cat0_obj2 = null;
  var $cat0_obj3 = null;
  var $cat1_obj1 = null;
  var $cat1_obj2 = null;
  var $cat1_obj3 = null;
  var $cat2_obj1 = null;
  var $cat2_obj2 = null;
  var $cat2_obj3 = null;
  var $cat3_obj1 = null;
  var $cat3_obj2 = null;
  var $cat3_obj3 = null;
  var $cat4_obj1 = null;
  var $cat4_obj2 = null;
  var $cat4_obj3 = null;
  var $clickBox = null;

  Cls.isAnimated = false;

  Cls.init = function () {
    $title = $("#seg4 .title1");
    $cat0_obj1 = $("#seg4 .cat0 .obj1");
    $cat0_obj2 = $("#seg4 .cat0 .obj2");
    $cat0_obj3 = $("#seg4 .cat0 .obj3");
    $cat1_obj1 = $("#seg4 .cat1 .obj1");
    $cat1_obj2 = $("#seg4 .cat1 .obj2");
    $cat1_obj3 = $("#seg4 .cat1 .obj3");
    $cat2_obj1 = $("#seg4 .cat2 .obj1");
    $cat2_obj2 = $("#seg4 .cat2 .obj2");
    $cat2_obj3 = $("#seg4 .cat2 .obj3");
    $cat3_obj1 = $("#seg4 .cat3 .obj1");
    $cat3_obj2 = $("#seg4 .cat3 .obj2");
    $cat3_obj3 = $("#seg4 .cat3 .obj3");
    $cat4_obj1 = $("#seg4 .cat4 .obj1");
    $cat4_obj2 = $("#seg4 .cat4 .obj2");
    $cat4_obj3 = $("#seg4 .cat4 .obj3");
    $clickBox = $("#seg4 .clickBox");
    Cls.clickable();
  };
  Cls.fixedAreaAnime = function () {
    if (firstFlag !== true)
      Anime.vertical($title, "-=100px", 700, 1200, "easeOutQuint");
    firstFlag = true;
  };
  Cls.clickable = function () {
    $clickBox.click(function () {
      if (nowCat === 0) {
        Cls.cat0();
      }
      if (nowCat === 1) {
        Cls.cat1();
      }
      if (nowCat === 2) {
        Cls.cat2();
      }
      if (nowCat === 3) {
        Cls.cat3();
      }
      if (nowCat === 4) {
        Cls.cat4();
      }
    });
  };

  Cls.cat0 = function () {
    if (!Cls.isAnimated) {
      Cls.isAnimated = true;
      $cat0_obj2.stop(true, true).css({ opacity: 0 });
      $cat0_obj3
        .stop(true, true)
        .css({ opacity: 0 })
        .delay(1000)
        .animate({ opacity: 1 }, 1000);
      $cat0_obj1
        .stop(true, true)
        .css({ opacity: 0 })
        .delay(1000)
        .animate({ opacity: 1 }, 1000, function () {
          $cat0_obj1.delay(1000).animate({ opacity: 0 }, 1200);
          $cat0_obj2.delay(1000).animate({ opacity: 1 }, 1200, Cls.endAnimate);
        });
      Cls.fixedAreaAnime();
    }
  };
  Cls.cat1 = function () {
    if (!Cls.isAnimated) {
      Cls.isAnimated = true;
      $cat1_obj3
        .stop(true, true)
        .css({ opacity: 0 })
        .delay(1000)
        .animate({ opacity: 1 }, 1000);
      $cat1_obj2.stop(true, true).css({ opacity: 0 });
      $cat1_obj1
        .stop(true, true)
        .css({ opacity: 0 })
        .delay(1000)
        .animate({ opacity: 1 }, 1000, function () {
          $cat1_obj1.delay(1000).animate({ opacity: 0 }, 1200);
          $cat1_obj2.delay(1000).animate({ opacity: 1 }, 1200, Cls.endAnimate);
        });
      Cls.fixedAreaAnime();
    }
  };
  Cls.cat2 = function () {
    if (!Cls.isAnimated) {
      Cls.isAnimated = true;
      $cat2_obj3
        .stop(true, true)
        .css({ opacity: 0 })
        .delay(1000)
        .animate({ opacity: 1 }, 1000);
      $cat2_obj2.stop(true, true).css({ opacity: 0 });
      $cat2_obj1
        .stop(true, true)
        .css({ opacity: 0 })
        .delay(1000)
        .animate({ opacity: 1 }, 1000, function () {
          $cat2_obj1.delay(1000).animate({ opacity: 0 }, 1200);
          $cat2_obj2.delay(1000).animate({ opacity: 1 }, 1200, Cls.endAnimate);
        });
      Cls.fixedAreaAnime();
    }
  };
  Cls.cat3 = function () {
    if (!Cls.isAnimated) {
      Cls.isAnimated = true;
      $cat3_obj3
        .stop(true, true)
        .css({ opacity: 0 })
        .delay(1000)
        .animate({ opacity: 1 }, 1000);
      $cat3_obj2.stop(true, true).css({ opacity: 0 });
      $cat3_obj1
        .stop(true, true)
        .css({ opacity: 0 })
        .delay(1000)
        .animate({ opacity: 1 }, 1000, function () {
          $cat3_obj1.delay(1000).animate({ opacity: 0 }, 1200);
          $cat3_obj2.delay(1000).animate({ opacity: 1 }, 1200, Cls.endAnimate);
        });
      Cls.fixedAreaAnime();
    }
  };
  Cls.cat4 = function () {
    if (!Cls.isAnimated) {
      Cls.isAnimated = true;
      $cat4_obj3
        .stop(true, true)
        .css({ opacity: 0 })
        .delay(1000)
        .animate({ opacity: 1 }, 1000);
      $cat4_obj2.stop(true, true).css({ opacity: 0 });
      $cat4_obj1
        .stop(true, true)
        .css({ opacity: 0 })
        .delay(1000)
        .animate({ opacity: 1 }, 1000, function () {
          $cat4_obj1.delay(1000).animate({ opacity: 0 }, 1200);
          $cat4_obj2.delay(1000).animate({ opacity: 1 }, 1200, Cls.endAnimate);
        });
      Cls.fixedAreaAnime();
    }
  };

  Cls.endAnimate = function () {
    setTimeout(function () {
      Cls.isAnimated = false;
    }, 500);
  };

  window.Seg4 = Cls;
})(window, $brand);
